import { render, staticRenderFns } from "./Ldygc.vue?vue&type=template&id=e98e7510&scoped=true&"
import script from "./Ldygc.vue?vue&type=script&lang=js&"
export * from "./Ldygc.vue?vue&type=script&lang=js&"
import style0 from "./Ldygc.vue?vue&type=style&index=0&id=e98e7510&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e98e7510",
  null
  
)

export default component.exports